import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootElement = document.getElementById("root");

// El prerender (scripts/prerender.mjs) genera HTML estático por ruta para SEO,
// AI crawlers y first-paint. En cliente NO hidratamos: ese HTML es un snapshot del
// DOM ya renderizado (sin los marcadores de SSR de React) y, combinado con animaciones
// (framer-motion) y CSS responsive, provoca mismatches de hidratación (React #418).
// Con createRoot, React monta en limpio sobre el contenedor → cero mismatch.
// El HTML estático sigue sirviéndose para crawlers; el usuario ve el first-paint y,
// al cargar el JS, React monta la app (contenido idéntico → swap imperceptible).
const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
